import React from 'react';

function Pagination10({
  totalItems,
  rowsPerPage,
  startIndex,
  onRowsPerPageChange,
  onFirstItems,
  onPreviousItems,
  onNextItems,
  onLastItems,
}) {
  const endIndex = Math.min(startIndex + rowsPerPage, totalItems);
  const isFirst = startIndex === 0;
  const isLast = endIndex >= totalItems;

  return (
    <div className="d-flex align-items-center justify-content-between" style={{ fontSize: 13 }}>

      {/* Exibir por página */}
      <div className="d-flex align-items-center gap-2">
        <span className="text-muted" style={{ whiteSpace: 'nowrap' }}>Exibir:</span>
        <select
          id="rowsPerPageSelect"
          className="form-select form-select-sm"
          style={{ width: 80 }}
          value={rowsPerPage}
          onChange={onRowsPerPageChange}
        >
          <option value={10}>10</option>
          <option value={30}>30</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={totalItems}>Todos</option>
        </select>
        <span className="text-muted">
          registros &nbsp;|&nbsp; <strong>{totalItems}</strong> no total
        </span>
      </div>

      {/* Navegação */}
      <div className="d-flex align-items-center gap-1">
        <button
          className="btn btn-sm btn-outline-success px-2"
          onClick={onFirstItems}
          disabled={isFirst}
          title="Primeira página"
        >
          <i className="bi bi-chevron-double-left" />
        </button>
        <button
          className="btn btn-sm btn-outline-success px-2"
          onClick={onPreviousItems}
          disabled={isFirst}
          title="Página anterior"
        >
          <i className="bi bi-chevron-left" />
        </button>

        <span
          className="px-3 py-1 rounded"
          style={{ background: '#e9ecef', fontWeight: 600, whiteSpace: 'nowrap', fontSize: 12 }}
        >
          {startIndex + 1} – {endIndex} / {totalItems}
        </span>

        <button
          className="btn btn-sm btn-outline-success px-2"
          onClick={onNextItems}
          disabled={isLast}
          title="Próxima página"
        >
          <i className="bi bi-chevron-right" />
        </button>
        <button
          className="btn btn-sm btn-outline-success px-2"
          onClick={onLastItems}
          disabled={isLast}
          title="Última página"
        >
          <i className="bi bi-chevron-double-right" />
        </button>
      </div>

    </div>
  );
}

export default Pagination10;
